import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=801a7fbc&scoped=true&lang=pug&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=801a7fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801a7fbc",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/prepayCards?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231207155841%2Fpages%2Fcompare-prepaid-credit-cards%2F_provider%2F_code%2F_slug.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsPrepayCardsSummary: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/products/prepay-cards/summary.vue').default,WidgetsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/widgets/accordion.vue').default,ProductsPrepayCardsFeatures: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/products/prepay-cards/features.vue').default,WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/widgets/list-item.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/site/feefo.vue').default})
